
























import Vue from 'vue'
import { PropValidator } from 'vue/types/options'
import { IDevice, IVW } from '@/types/model'
import RadioIcon from '@/components/RadioIcon.vue'
import VwPreviewScreen from '@/components/VwPreviewScreen.vue'
import EnableIndicator from '@/components/EnableIndicator.vue'
import easyapi from '@/easyapi'
import mixins from 'vue-typed-mixins'
import { thumb_size_t } from '@/store/modules/pref'
import { Preset } from '@/types/api'

export default Vue.extend({
  components: {
    RadioIcon,
    EnableIndicator
  },
  props: {
    /** Currently chosen in this radio group. Use v-model to access this. */
    preset: {
      type: Object
    } as PropValidator<Preset>
  },
  computed: {
  },
  methods: {
    openRenameDialog () { this.$router.push({ name: 'preset_rename', params: { presetid: this.preset.id + '' }}) },
    openEditDialog () { this.$router.push({ name: 'preset_edit', params: { presetid: this.preset.id + '' }}) },
    openDetailDialog () { this.$router.push({ name: 'preset_details', params: { presetid: this.preset.id + '' }}) },
    openDeleteDialog () { this.$router.push({ name: 'preset_delete', params: { presetid: this.preset.id + '' }}) },
  }
})
